export function initCalendar() {
    let currentDate = new Date();
    const header = document.getElementById('po-current-month');
    const prevBtn = document.getElementById('po-prev');
    const nextBtn = document.getElementById('po-next');
    const grid = document.getElementById('po-calendar-grid');
    const eventsDate = document.getElementById('po-events-date');
    const phpBlock = document.getElementById('po-events-list-php');
    const ajaxBlock = document.getElementById('po-events-list-ajax');

    if (!header || !prevBtn || !nextBtn || !grid || !eventsDate || !ajaxBlock) {
        return;
    }

    function renderCalendar(year, month) {
        currentDate.setFullYear(year);
        currentDate.setMonth(month - 1);

        fetch(`${ajax.url}?action=po_get_calendar_month&year=${year}&month=${month}`)
            .then(res => res.json())
            .then(data => {
                if (data.success && data.data.html) {
                    grid.innerHTML = data.data.html;
                    header.textContent = new Date(year, month - 1).toLocaleString('en-GB', {
                        month: 'long',
                        year: 'numeric'
                    });

                    if (data.data.prev_month_name && data.data.next_month_name) {
                        prevBtn.querySelector('.po-month-name').textContent = data.data.prev_month_name;
                        nextBtn.querySelector('.po-month-name').textContent = data.data.next_month_name;
                    }

                    bindDayClicks(year, month);
                    autoSelectDay(year, month);
                }
            });
    }

    function autoSelectDay(year, month) {
        let dayCell = grid.querySelector('.po-day.today') || grid.querySelector('.po-day:not(.po-day--other)');
        if (dayCell) {
            grid.querySelectorAll('.po-day').forEach(cell => cell.classList.remove('selected'));
            dayCell.classList.add('selected');
            const day = dayCell.dataset.day;
            const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            eventsDate.textContent = new Date(dateStr).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
            loadEventsByDate(dateStr);
        }
    }

    function bindDayClicks(year, month) {
        grid.querySelectorAll('.po-day').forEach(cell => {
            cell.addEventListener('click', function () {
                grid.querySelectorAll('.po-day.selected').forEach(c => c.classList.remove('selected'));
                cell.classList.add('selected');
                const day = cell.dataset.day;
                const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                if (phpBlock) phpBlock.style.display = 'none';
                if (ajaxBlock) ajaxBlock.style.display = '';
                loadEventsByDate(dateStr);
            });
        });
    }

    function loadEventsByDate(dateStr) {
        fetch(`${ajax.url}?action=po_get_events_by_date&date=${dateStr}`)
            .then(res => res.json())
            .then(data => {
                ajaxBlock.innerHTML = '';
                ajaxBlock.innerHTML += `<div class="po-events-wrap"><span></span><div class="po-events-date">${new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div><span></span></div>`;
                if (!data.success || !data.data.length) {
                    ajaxBlock.innerHTML += `
                  <div class="po-no-events">
                    <img src="${poCalendarData.assetsUrl}no-events.png" alt="No events illustration">
                     <div class="po-no-events__text">No events on this day.</div>
                  </div>
               `;
                    return;
                }
                ajaxBlock.innerHTML += '<div class="po-events-list">';
                data.data.forEach(event => {
                    console.log('Event data:', event);
                    ajaxBlock.innerHTML += `
                  <div class="po-event-card">
                     <div class="po-event-card__thumb-wrapper">
                        <div class="po-event-card__thumb">
                           <img src="${event.thumb}" alt="${event.title}" width="350" height="200">
                           <span class="po-event-card__type">
                              <span class="po-event-card__dot po-dot_type_${event.type}"></span>
                              ${event.type_name}
                           </span>
                        </div>
                     </div>
                     <div class="po-event-card__body">
                        <div class="top-card__wrapper">
                           <div class="po-event-card__title">${event.title}</div>
                        </div>
                        <div class="po-event-card__status ${event.status}">
                           ${event.status_label}
                        </div>
                        <div class="po-event-card__details">
                           ${event.prize ? `<div>Prize fund: <b>${event.prize}</b></div>` : ''}
                           ${event.fee ? `<div>Participation fee: <b>${event.fee}</b></div>` : ""}
                           ${event.duration ? `<div>Duration: <b>${event.duration}</b></div>` : ""}
                           ${event.time && event.time !== '00:00' ? `<div>Kick off: <b>${event.time}</b></div>` : ''}
                        </div>
                        <div class="po-event-card__footer">
                           ${event.button_html}
                        </div>
                     </div>
                  </div>
               `;
                });
                ajaxBlock.innerHTML += '</div>';
            })
            .catch(error => console.error('Error loading events:', error));
    }

    prevBtn.addEventListener('click', () => {
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        month--;
        if (month < 1) {
            month = 12;
            year--;
        }
        renderCalendar(year, month);
    });

    nextBtn.addEventListener('click', () => {
        let year = currentDate.getFullYear();
        let month = currentDate.getMonth() + 1;
        month++;
        if (month > 12) {
            month = 1;
            year++;
        }
        renderCalendar(year, month);
    });

    renderCalendar(currentDate.getFullYear(), currentDate.getMonth() + 1);
}